import Select from './src/select.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';

export const ToSelect: SFCWithInstall<typeof Select> = withInstall(Select);

export * from './src/instance';
